









































import type { PropType } from 'vue';
import { defineComponent, computed, ref } from '@nuxtjs/composition-api';
import DraggableDiv from '~/components/atoms/DraggableDiv/DraggableDiv.vue';
import ThumbnailCarouselItem from '~/components/molecules/Product/ThumbnailCarouselItem/ThumbnailCarouselItem.vue';
import CarouselArrowButton from '~/components/atoms/Buttons/CarouselArrowButton/CarouselArrowButton.vue';
import { useThumbnailCarouselClicks } from '~/composables';
import type { ThumbnailItem } from '~/types/components/ThumbnailCarousel/ThumbnailItem';

export default defineComponent({
  name: 'PdpThumbnailCarouselMobile',
  components: {
    DraggableDiv,
    ThumbnailCarouselItem,
    CarouselArrowButton,
  },
  props: {
    sliderItems: {
      type: Array as PropType<Array<ThumbnailItem>>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const currentTranslateX = ref(0);
    const thumbnailDimension = 40;
    const thumbnailGap = 8;
    const currentIndex = ref(0);
    const maxSliderItemsDisplayed = 5;

    const visibleItemsCount = computed(() => Math.min(maxSliderItemsDisplayed, props.sliderItems.length));

    const { handlePrevClickHelper, handleNextClickHelper, carouselArea } = useThumbnailCarouselClicks({
      thumbnailGap,
      thumbnailDimension,
      visibleItemsCount: visibleItemsCount.value,
      sliderItemsLength: props.sliderItems.length,
    });

    const carouselHeight = computed(() => `${thumbnailDimension}px`);

    const carouselStyles = computed(() => ({
      transform: `translateX(${currentTranslateX.value}px)`,
      transition: 'transform 0.5s ease',
    }));

    const hasPrev = computed(() => currentIndex.value > 0);
    const hasNext = computed(() => (currentIndex.value + visibleItemsCount.value) < props.sliderItems.length);

    const hasArrows = computed(() => props.sliderItems.length > 5);

    const handlePrevClick = () => {
      const clickResult = handlePrevClickHelper(currentIndex.value);
      if (clickResult) {
        currentIndex.value = clickResult.newCurrentIndex;
        currentTranslateX.value = clickResult.newPlacement;
      }
    };

    const handleNextClick = () => {
      const clickResult = handleNextClickHelper(currentIndex.value);
      if (clickResult) {
        currentIndex.value = clickResult.newCurrentIndex;
        currentTranslateX.value = clickResult.newPlacement;
      }
    };

    const handleItemClick = (item: ThumbnailItem) => {
      emit('item-click', { index: item.originalIndex });
    };

    return {
      handlePrevClick,
      handleNextClick,
      handleItemClick,
      carouselArea,
      carouselStyles,
      hasPrev,
      hasNext,
      hasArrows,
      carouselHeight,
      thumbnailDimension,
    };
  },
});
